import { render, staticRenderFns } from "./vipTab.vue?vue&type=template&id=e31b0990&scoped=true&lang=pug"
import script from "./vipTab.vue?vue&type=script&lang=js"
export * from "./vipTab.vue?vue&type=script&lang=js"
import style0 from "./vipTab.vue?vue&type=style&index=0&id=e31b0990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31b0990",
  null
  
)

export default component.exports